import React from "react"

const RichButton = ({ button }) => {
  let base = "inline-block mr-1 mb-2 px-4 py-2 rounded-full leading-none"
  let primary = "bg-green-300 hover:bg-green-400 dark:bg-green-700 hover:dark:bg-green-800"
  let secondary = "bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-800 hover:dark:bg-neutral-900"
  let style = secondary
  if (button.style === 'primary') {
    style = primary
  }

  if (button.file !== null) {
    return (
      <a className={`${base} ${style}`} href={button.file.localFile.publicURL}>{button.title}</a>
    )
  } else {
    return (
      <a className={`${base} ${style}`} href={button.url}>{button.title}</a>
    )
  }
}

export default RichButton
